var React = require('react');

function Contrast (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M48 72C54.3652 72 60.4697 69.4714 64.9706 64.9706C69.4714 60.4697 72 54.3652 72 48C72 41.6348 69.4714 35.5303 64.9706 31.0294C60.4697 26.5286 54.3652 24 48 24V72Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Contrast.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Contrast;

Contrast.default = Contrast;
